export const optionsWithoutOTA = [
    {
        label: "Problemas de mantenimiento en el hotel",
        value: "Problemas de mantenimiento en el hotel",
    },
    {
        label: "Problemas con el personal del hotel",
        value: "Problemas con el personal del hotel",
    },
    {
        label: "Detalles de limpieza en la habitación",
        value: "Detalles de limpieza en la habitación",
    },
    {
        label: "Cambio de planes por parte del Huésped",
        value: "Cambio de planes por parte del Huésped",
    },
    { label: "Otro", value: "Otro" },
]

export const optionsWithOTA = [
    {
        label: "Cambio de planes de viaje",
        value: "Cambio de planes de viaje",
    },
    {
        label: "Problemas de salud del huespéd",
        value: "Problemas de salud del huespéd",
    },
    {
        label: "Emergencia familiar",
        value: "Emergencia familiar",
    },
    {
        label: "Condiciones climáticas adversas",
        value: "Condiciones climáticas adversas",
    },
    {
        label: "Cambio o error en la reserva",
        value: "Cambio o error en la reserva",
    },
    {
        label: "Inconformidad con las políticas del hotel",
        value: "Inconformidad con las políticas del hotel",
    },
    {
        label: "Problemas financieros",
        value: "Problemas financieros",
    },
    {
        label: "Cancelación de vuelos o transporte",
        value: "Cancelación de vuelos o transporte",
    },
    {
        label: "Desastre natural",
        value: "Desastre natural",
    },
    {
        label: "Problemas laborales o de agenda",
        value: "Problemas laborales o de agenda",
    },
    {
        label: "Mejores opciones de alojamiento disponibles",
        value: "Mejores opciones de alojamiento disponibles",
    },
    {
        label: "Fallas en la confirmación de la reserva",
        value: "Fallas en la confirmación de la reserva",
    },
    {
        label: "Problemas de documentación (Pasaportes o visas)",
        value: "Problemas de documentación (Pasaportes o visas)",
    },
    {
        label: "Conflictos con eventos o actividades planeadas",
        value: "Conflictos con eventos o actividades planeadas",
    },
    {
        label: "Insatisfacción con las instalaciones o servicios",
        value: "Insatisfacción con las instalaciones o servicios",
    },
    {
        label: "Otro",
        value: "Otro",
    },
]